import React, { Component } from 'react';
import { Query } from 'react-apollo';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import '../../style/FontLibrary.scss';
import queries from '../../queries';
import { t } from '../../i18n';

// Charge la police pour que son nom s'affiche dans sa propre typographie (aperçu).
const loaded = new Set();
function preview(font) {
  const family = `tsk-lib-${font.uri}`;
  if (loaded.has(family)) return family;
  loaded.add(family);
  try {
    const face = new FontFace(family, `url(${font.uri})`);
    face.load().then((f) => document.fonts.add(f)).catch(() => {});
  } catch (e) { /* aperçu indisponible */ }
  return family;
}

// Bibliothèque des polices déjà utilisées dans les autres interfaces : un clic pour la réutiliser.
class FontLibrary extends Component {

  state = { search: '' };

  componentDidMount() { window.addEventListener('keydown', this.onKey); }
  componentWillUnmount() { window.removeEventListener('keydown', this.onKey); }
  onKey = (e) => { if (e.key === 'Escape') this.props.onClose(); };

  // Une police = un nom + un fichier ; on regroupe les doublons et on retient les interfaces qui l'utilisent.
  collect(data) {
    const byKey = {};
    [...(data.projects || []), ...(data.archivedProjects || [])].forEach((project) => {
      (project.fonts || []).forEach((font) => {
        const key = `${font.name}|${font.uri}`;
        if (!byKey[key]) byKey[key] = { name: font.name, uri: font.uri, projects: [] };
        if (!byKey[key].projects.includes(project.name)) byKey[key].projects.push(project.name);
      });
    });
    return Object.values(byKey).sort((a, b) => a.name.localeCompare(b.name));
  }

  render() {
    const { onSelect, onClose, usedNames } = this.props;
    const { search } = this.state;
    return (
      <div className='tsk-ui-modal-overlay' onMouseDown={onClose}>
        <div className='tsk-ui-modal-surface tsk-fontlib' role='dialog' aria-label={t('ui.font.dialog_aria')} onMouseDown={(e) => e.stopPropagation()}>
          <h3 className='tsk-ui-modal__title'>{t('ui.font.title')}</h3>
          <p className='tsk-settings-hint'>{t('ui.font.hint')}</p>
          <input
            type='search'
            autoFocus
            placeholder={t('ui.font.search')}
            value={search}
            onChange={(e) => this.setState({ search: e.target.value })}
          />
          <Query query={queries.projects.allFonts} fetchPolicy='cache-and-network'>
            {({ data, loading, error }) => {
              if (error) return <p className='tsk-fontlib__empty'>{t('ui.font.error')}</p>;
              if (!data || (!data.projects && loading)) return <p className='tsk-fontlib__empty'>{t('ui.common.loading')}</p>;
              const all = this.collect(data).filter((f) => f.name.toLowerCase().includes(search.trim().toLowerCase()));
              if (all.length === 0) return <p className='tsk-fontlib__empty'>{search ? t('ui.font.none_match') : t('ui.font.none')}</p>;
              return (
                <ul className='tsk-fontlib__list'>
                  {all.map((font) => {
                    const already = usedNames.includes(font.name);
                    return (
                      <li key={`${font.name}|${font.uri}`}>
                        <button type='button' disabled={already} onClick={() => onSelect({ name: font.name, uri: font.uri })}>
                          <span className='tsk-fontlib__sample' style={{ fontFamily: `"${preview(font)}", sans-serif` }}>{font.name}</span>
                          <small>
                            {already
                              ? t('ui.font.already')
                              : t('ui.font.used_in', { names: `${font.projects.slice(0, 2).join(', ')}${font.projects.length > 2 ? ` +${font.projects.length - 2}` : ''}` })}
                          </small>
                          {!already && <FontAwesomeIcon icon={['fas', 'plus']} />}
                        </button>
                      </li>
                    );
                  })}
                </ul>
              );
            }}
          </Query>
          <div className='tsk-ui-modal__actions'>
            <button type='button' className='tsk-button' onClick={onClose}>{t('ui.common.close')}</button>
          </div>
        </div>
      </div>
    );
  }
}

export default FontLibrary;
